import HttpServer from '@yunxi/request';
import { message } from 'ant-design-vue';
import { AxiosRequestConfig } from 'axios';

import tokenServer from '@/service/token';

const toLogin = async () => {
  if (location.href.includes('/login')) return false;
  tokenServer.removeToken();
  location.reload();
};

const axiosOpts = {
  baseURL:
    import.meta.env.MODE === 'development' ? '/api' : <string>import.meta.env.VITE_APP_BASE_API,
  timeout: 1000 * 10,
};

const handleRequest = (config: AxiosRequestConfig) => {
  if (config.headers) {
    config.headers.authorization = <string>tokenServer.getToken();
    config.headers.source = '6';
  }
  return config;
};

export const http = new HttpServer(axiosOpts, {
  // debugger: true,
  handleRequest,
  errorHandle: async response => {
    if ([130603011, 130603012].includes(response.code)) return false;
    switch (response.code) {
      case 401:
        message.error('您未登录，或者登录已经超时，请先登录！');
        await toLogin();
        break;
      case 500:
        message.error('服务器内部错误！');
        break;
      default:
        message.error(<string>response.msg || '请求出错，请检查');
        break;
    }
  },
});
export const rawHttp = new HttpServer(axiosOpts, {
  raw: true,
  handleRequest,
});
